import * as types from './mutations-types'

const setCentroCusto = async ({commit}, obj) => {
  const {data} = await axios.post(`${process.env.API_PATH}/centrocusto/`, obj)
}

const setSelected = async ({commit}, obj) => {
  const {data} = await axios.get(`${process.env.API_PATH}/centrocusto/${obj.id}`)
  commit(types.SET_SELECTED, {selected : data})
}
const update = async ({commit}, obj) => {
  const {data} =  await axios.put(`${process.env.API_PATH}/centrocusto/${obj.id}`,  obj )
}

const updateSeeder = async ({commit}, obj) => {
  const {data} =  await axios.put(`${process.env.API_PATH}/centrocusto/${obj.id}/seeder`,  { binds : obj.binds } )
}


const setList = async ({commit}, obj) => {
  const {data} = await axios.get(`${process.env.API_PATH}/centrocusto`)
  commit(types.SET_LIST, {list : data})
}

export default {
  setSelected,update,setList,updateSeeder,setCentroCusto
}



// WEBPACK FOOTER //
// ./src/features/Centro/store/actions.js